module.exports = __webpack_public_path__ + "static/media/AIR-FREIGHT.000eac33.jpg";